// extracted by mini-css-extract-plugin
export var typingIndicator = "_mc-0";